import React from 'react'
import _ from 'underscore'
import { ChevronDown } from 'lucide-react'
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar'
import { DropdownMenu } from './dropdown_menu'

const ManagerContent = ({ manager, show_count }) => {
  const name = manager.short_name || manager.name

  return (
    <span className="flex min-w-0 items-center gap-2">
      <Avatar size="sm">
        <AvatarImage src={manager.profile_picture_url}/>
        <AvatarFallback>{(name || '?').charAt(0)}</AvatarFallback>
      </Avatar>
      <span className="truncate">
        {name}{show_count && manager.count != null ? ` (${manager.count})` : ''}
      </span>
    </span>
  )
}

// Searchable manager dropdown for the LS/SDR filters: DropdownMenu's pinned
// search box, with options rendered as profile picture + short name like the
// enquiry header's ManagerSelect. Search matches on the full name.
//
// onChange receives '' for the unset option, a special option's value
// verbatim (e.g. 'any' / 'none'), or the selected manager's id as a string.
class ManagerFilter extends React.Component {

  onItemClick = (value) => {
    this.props.onChange(value)
  }

  getItems = () => {
    const managers = this.props.managers || []
    const selected = this.props.selected

    // Merge an off-list selection in so historical assignments still display.
    let list = managers
    if (selected && !_.find(managers, (manager) => `${manager.id}` === `${selected.id}`)) {
      list = [selected].concat(managers)
    }

    const unset = this.props.can_unset === false
      ? []
      : [{ value: '', name: this.props.placeholder }]

    return [
      ...unset,
      ...(this.props.special_options || []),
      ...list.map((manager) => ({
        value: `${manager.id}`,
        name: manager.name || manager.short_name || '',
        count: manager.count,
        content: <ManagerContent manager={manager}/>
      }))
    ]
  }

  renderTriggerContent = () => {
    if (this.props.selected) {
      return <ManagerContent manager={this.props.selected} show_count={true}/>
    }

    const special = _.find(this.props.special_options || [], (option) => {
      return `${option.value}` === `${this.props.selected_special}`
    })

    if (special) {
      return special.name
    }

    return this.props.placeholder
  }

  render() {
    const selected = this.props.selected
      ? `${this.props.selected.id}`
      : (this.props.selected_special || '')

    return (
      <DropdownMenu
        searchable
        disabled={this.props.disabled}
        items={this.getItems()}
        selected={selected}
        onItemClick={this.onItemClick}
        buttonClassName="btn-outline btn-sm min-w-0 w-full justify-between font-normal"
      >
        <span className="flex min-w-0 flex-1 items-center truncate">{this.renderTriggerContent()}</span>
        <ChevronDown className="size-3.5 shrink-0 opacity-50"/>
      </DropdownMenu>
    )
  }
}

export default ManagerFilter
